/* eslint @typescript-eslint/no-unused-vars: "off" */

import React, {useState, useEffect} from "react";
import {useAtomValue, useAtom} from "jotai";
import convert from "convert-units";
import { JsonView, allExpanded, defaultStyles } from 'react-json-view-lite';
import 'react-json-view-lite/dist/index.css';

import {genSpeech} from "../state/audio";
import {logState} from "../utils";
import {
  RecipeT,
  IngredientT,
  StepT,
  secIter,
  Status,
  StatusValue,
  setStatus,
  ContainerT,
  sessionIdAtom,
  activesAtom,
  errorAtom,
  focusedAtom,
  currentAtom,
  jumpAtom,
  objByIdAtom,
  switchFocused,
  updateCurrentAtom,
  getIngrQuantity,
} from "../state/active";
import {createTimer} from "../state/timer";
import styles from "./Active.module.css";

const UNIT_MAP = {
  tablespoon: "Tbs",
  tbsp: "Tbs",
  tbs: "Tbs",
  teaspoon: "tsp",
  tspn: "tsp",
  ounce: "fl-oz",
};

// "increments" status
const incrStatus = (status: StatusValue) => {
  switch (status) {
    case "todo":
      return "cur";
    case "cur":
      return "done";
    case "done":
      return "todo";
  }
};

interface AnnotationProps {
  text: string;
  source: string;
  ts: string;
  recipe: RecipeT;
  updateCurrent: (obj: {field: string; value: any}) => void;
}

const Annotation = ({text, source, ts, updateCurrent, recipe, ...anno}: AnnotationProps) => {
  const sessionId = useAtomValue(sessionIdAtom);
  const classes = [styles.annotation, styles[`source-${source}`]];
  console.log('rendering annotation', text, source, ts, anno, sessionId, anno.sessionId===sessionId);
  const iconStyle = {position: 'relative', top: 3, height: 14};
  const removeAnnotation = () => {
    console.log('removing annotation', anno);
    fetch(`/api/annotate/`, {
      method: "DELETE",
      headers: {"Content-Type": "application/json"},
      body: JSON.stringify({id: anno.id, sessionId}),
    }).then((res) => res.json()).then((obj) => {
      console.log("got annotation result", obj);
      // update annotations
      const newAnnotations = (recipe.annotations || []).filter((a) => a.id !== anno.id);
      updateCurrent({field: "annotations", value: newAnnotations});
    });
  }
  return (
    <div className={classes.join(" ")}>
      {(anno.sessionid === sessionId) && <img src="/icons/red-x.png" style={iconStyle} onClick={removeAnnotation} />}
      <span className={styles.ts}>{ts}</span>
      <span className={styles.note}>{text}</span>
    </div>
  );
};


const addAnnotation = ({recipe, target, sessionId, updateCurrent}) => {
  const text = window.prompt("Enter your annotation:");
  if (text) {
    const data = {dish_id: recipe.dish.id, target, text, source: "cookery", sessionId};
    console.log("adding annotation", data);
    fetch("/api/annotate/", {
      method: "POST",
      headers: {"Content-Type": "application/json"},
      body: JSON.stringify(data),
    }).then((res) => res.json()).then((obj) => {
      console.log("got annotation result", obj);
      // update annotations
      const newAnnotations = [...recipe.annotations] || [];
      newAnnotations.push(obj.annotation);
      updateCurrent({field: "annotations", value: newAnnotations});
    });
  }
};

interface ContainerProps {
  id: string;
  idx: number;
  status: Status;
  recipe: RecipeT;
  sessionId: string;
}

interface IngredientProps extends ContainerProps {
  ingr: IngredientT;
}

const Ingredient = ({ingr, idx, status, id, recipe, sessionId}: IngredientProps) => {
  const [substitutes, setSubstitutes] = useState([]);
  let {full_item, unit, min, max, notes} = ingr;
  const [_, updateCurrent] = useAtom(updateCurrentAtom);
  //console.log("in ingredient with", item, unit, quantity, ingr, loc, status);
  /*
  const [flipUnit, setFlipUnit] = useState(false);

  // flips our quantity/unit and returns new quantity and unit
  const flip_quantity = () => {
    // first normalize input unit as much as possible
    let orig = unit.toLowerCase().trim();
    if (orig[orig.length - 1] === "s") {
      orig = orig.slice(0, -1);
    }
    if (UNIT_MAP[orig]) {
      orig = UNIT_MAP[orig];
    }
    // we only support a small number of output units for now
    const out_units = ["ml", "g"];
    let out_unit = null;
    out_units.forEach((u) => {
      try {
        if (convert().from(orig).possibilities().includes(u)) {
          out_unit = u;
        }
      } catch (e) {
        console.log("error", e, orig, u);
      }
    });
    console.log("orig", orig, quantity, typeof quantity, out_unit);
    return {
      quantity: out_unit ? convert(quantity).from(orig).to(out_unit).toFixed(1) : quantity,
      unit: out_unit || unit,
      item,
    };
  };
  const finalIngr = flipUnit ? flip_quantity() : ingr;
  //const finalIngr = ingr;
  */
  const classes = [styles.ingredient, styles[status]];

  const getSubstitutions = () => {
    if (substitutes.length > 0) {
      return;
    }
    fetch(`/api/substitute/?ingredient=${full_item}`).then((res) => res.json()).then((data) => {
      console.log("got substitution result", data);
      setSubstitutes(data.suggestions);
    });
  };

  const addToGroceryList = () => {
    fetch("/api/groceries/", {
      method: "POST",
      headers: {"Content-Type": "application/json"},
      body: JSON.stringify({name: ingr.full_item}),
    }).then((res) => res.json()).then((obj) => {
      console.log("added to grocery list", ingr, obj);
    });
  }

  let curEls = [];
  if (true || status !== "done") { //FIXME see what conditions I want here
    curEls.push(<img src="/icons/food-substitution.png" key="get-sub"
        style={{width: 25, marginLeft:10, position: 'relative', top: 7}}
        onClick={getSubstitutions}
        /> );
    curEls.push(<img src="/icons/voice-note.png" key="voice-note"
        style={{height: 20, marginLeft:10, position: 'relative', top: 3}}
        onClick={() => addAnnotation({recipe, target: ingr.id, sessionId, updateCurrent})}
        /> );
    curEls.push(<img src="/icons/grocery-list.png" key="grocery-list"
        style={{height: 20, marginLeft:10, position: 'relative', top: 3}}
        onClick={addToGroceryList}
        /> );
    if (substitutes.length > 0) {
      curEls.push(
        <div key="subs" className={styles.substitutes}>
          {substitutes.map((s, i) => (
            <div key={i} className={styles.substitute}>{s}</div>
          ))}
        </div>
      );
    }
    curEls.push(...renderAnnotations({recipe, target: ingr.id, updateCurrent}));
  }

  return (
    <div className={classes.join(" ")} id={id}>
      <input
        type="checkbox"
        checked={status === "done"}
        onChange={() =>
          setStatus({obj: "ingr", idx, status: status === "done" ? "todo" : "done"})
        }
      />
      <span className={styles.quantity}>{getIngrQuantity(ingr, recipe)}</span>
      <span className={styles.unit} onClick={() => setFlipUnit(!flipUnit)}>
        {unit}
      </span>
      <span
        className={styles.item}
        onClick={() => setStatus({obj: "ingr", idx, status: "cur"})}
      >
        {full_item}
        {notes && notes.length > 0 && <span className={styles.notes}> ({notes.join(", ")})</span>}
      </span>
      {curEls}
    </div>
  );
};


const ShortIngr = ({id, obj, step, status, recipe, ...props}: IngredientProps) => {
  //console.log('in short ingr', id, obj, status, props);
  // Check if all ingredients for this step are done
  const getObjById = useAtomValue(objByIdAtom);
  const allIngredientsDone = step?.ingredients?.every(ingrId => {
    const ingredient = getObjById(ingrId);
    return ingredient.status === "done";
  });

  const handleClick = () => {
    const newStatus = (status === "done") ? "cur" : "done";
    setStatus({obj: "ingr", id, status: newStatus});
  };
  const classes = [styles.matchedIngr, styles[status]];
  if (allIngredientsDone) {
    classes.push(styles.allIngredientsDone);
  }
  //console.log('for shortingr', id, obj, step, allIngredientsDone, classes);
  let s = `${getIngrQuantity(obj, recipe)} ${obj.unit} ${obj.full_item}`;
  if (obj.notes.length > 0) {
    s += ` (${obj.notes.join(', ')})`;
  }
  return <span className={classes.join(' ')} onClick={handleClick}>{s}</span>;
}

interface TimerProps {
  name: string;
  h: number;
  m: number;
  s: number;
  recipeName?: string;
}

const InlineTimer = ({name, h, m, s, recipeName}: TimerProps) => {
  // construct timer string from h, m, s by 0-padding, removing unused left els, and combining with :
  // note that h, m, s are numbers
  let timerStr = '';
  const makeStr = (n) => n.toString().padStart(2, '0');
  const els = [h, m, s].map(makeStr);
  while (els[0] === '00') {
    els.shift();
  }
  timerStr = els.join(':');
  const timerMs = (h * 60 * 60 + m * 60 + s) * 1000;
  return (
    <div
      key={name}
      className={styles.matchedTimer}
      onClick={() => {
        console.log("starting timer", name, timerMs);
        createTimer(name, timerMs, recipeName);
      }}
    >
      {name} {timerStr}
    </div>
  );
};

interface StepProps extends ContainerProps {
  step: StepT;
}

// Renders annotations for a target id
const renderAnnotations = ({recipe, target, updateCurrent}) => {
    const annos = (recipe.annotations || []).filter((a) => {
      if (target === null) {
        return a.target === null || a.target === undefined;
      } else {
        return a.target === target;
      }
    });
    const ret = [];
    if (annos.length > 0) {
      ret.push(
        <div key="annos" className={styles.annotations}>
          {annos.map((a, i) => <Annotation key={i} updateCurrent={updateCurrent} recipe={recipe} {...a} />)}
        </div>
      );
    }
    return ret;
};

const Step = ({idx, step, status, id, recipeName, recipe, sessionId}: StepProps) => {
  const getObjById = useAtomValue(objByIdAtom);
  console.debug("in step with", id, step, idx, status);
  const classes = [styles.step, styles[status]];

  const [_, updateCurrent] = useAtom(updateCurrentAtom);
  let additional = null;
  const timerBtn = (timer) => {
  };
  additional = [];
  additional.push(<img src="/icons/voice-note.png" key="voice-note" style={{height: 20, marginLeft:10, position: 'relative', top: 3}}
              onClick={() => addAnnotation({recipe, target: id, sessionId, updateCurrent})} />);
  if (status !== "done") {
    additional.push(...step.ingredients.map(ingrId => <ShortIngr key={ingrId} recipe={recipe} step={step} {...getObjById(ingrId)} />));
    additional.push(...step.timers.map(timer => <InlineTimer key={timer.name} recipeName={recipeName} {...timer} />));
    additional.push(...renderAnnotations({recipe, target: id, updateCurrent}));
    if (additional.length > 0) {
      <div key="additional" className={styles.additional}>{additional}</div>
    }
  }
  return (
    <div className={classes.join(" ")} id={id}>
      <input
        type="checkbox"
        checked={status === "done"}
        onChange={() =>
          setStatus({obj: "step", idx, status: status === "done" ? "todo" : "done"})
        }
      />
      {idx + 1}.{" "}
      <span className="stepText" onClick={() => setStatus({obj: "step", idx, status: "cur"})}>{step.text}</span>
      {additional}
    </div>
  );
};

const TimeBlock = ({r}: {r: RecipeT}) => {
  console.log('got r time', r.times);
  return Object.entries(r.times).map(([name, time]) => <span>{name}: {time} mins </span>);
};

const IncrRange = ({label, min, max, step, value, updateValue}) => {
  const setValue = (incr) => {
    console.log('types', typeof value, typeof incr, typeof min, typeof max, typeof step);
    let v = value + incr;
    console.log('got first v', v, value);
    v = Math.min(max, Math.max(min, v));
    console.log('second v', v);
    // clamp it to be a multiple of step
    // e.g., if step is 0.5, and v is 2.3, we want to round it to 2.5
    v = Math.round(v / step) * step;
    console.log('in set value', incr, v, label, min, max, step, value);
    updateValue(v);
  }
  return (
    <>
        <span> | {label}: </span>
        <button onClick={() => setValue(-step)}>-</button>
        <input type="range" min={min} max={max} step={step} value={value} onChange={(e) => updateValue(parseFloat(e.target.value))} />
        <button onClick={() => setValue(step)}>+</button>
        <div style={{width: 40, display: 'inline-block'}}> {value.toFixed(1)}</div>
    </>
  );
}

const Recipe = ({r}: {r: RecipeT}) => {
  const [newServings, setNewServings] = useState(r.servings);
  const [_, updateCurrent] = useAtom(updateCurrentAtom);
  const [jump, setJump] = useAtom(jumpAtom);
  const sessionId = useAtomValue(sessionIdAtom);
  console.log("rendering recipe", r, jump, r.dish);
  useEffect(() => {
    console.log('in jump effect', jump);
    if (jump) {
      const el = document.getElementById(jump);
      if (el) {
        el.scrollIntoView({behavior: "smooth", block: "center"});
        // add an animation that highlights it for a second
        el.classList.add(styles.jump);
        setTimeout(() => {
          el.classList.remove(styles.jump);
        }, 2000);
      }
      setJump(null);
    }
  }, [jump]);
  useEffect(() => {
    logState({_name: 'active-recipe', jump, sessionId});
  }, [jump, sessionId]);
  const toRender = {steps: [], ingredients: []};
  for (const name of ["ingredients", "steps"]) {
    r[name].forEach((obj, idx) => {
      if (idx === 0 || obj.section !== r[name][idx - 1].section) {
        toRender[name].push(<h4 key={obj.section}>{obj.section}</h4>);
      }
      const common = {idx, id: obj.id, status: obj.status, recipeId: r.dish.id, recipeName: r.name, recipe: r, sessionId};
      let Component = null;
      if (name === "ingredients") {
        Component = Ingredient;
        common.ingr = obj.obj;
      } else {
        Component = Step;
        common.step = obj.obj;
      }
      toRender[name].push(<Component key={idx} {...common} />);
    });
  }
  const updateServings = (v) => {
    setNewServings(v);
    // update recipe scale
    updateCurrent({field: "scale", value: v / r.servings});
  }
  const updateScale = (v) => {
    updateCurrent({field: "scale", value: v});
    // also update servings
    setNewServings(r.servings * v);
  }
  return (
    <>
    <div className={styles.recipe}>
      <h2>{r.name}</h2>
      <div className={styles.metadata}>
        <a href={r.dish.dropbox_shared_link} target="_blank">
          <img src="/icons/dropbox.png" style={{width: 20, position: "relative", top: 3}} />
        </a>
        <a href={r.dish.recipe_url} target="_blank" rel="noreferrer">
          <img src="/icons/web.png" style={{width: 20, position: "relative", top: 3}} />
        </a>
        <img src="/icons/voice-note.png" style={{height: 20, marginLeft:10, position: 'relative', top: 3}}
             onClick={() => addAnnotation({recipe: r, target: null, sessionId, updateCurrent})} />
        <TimeBlock r={r} />
        <span>Original Servings: {r.servings}</span>
        <IncrRange label="New servings" min={0.5} max={r.servings*10} step={0.5} value={newServings} updateValue={updateServings} />
        <IncrRange label="Scale" min={0.1} max={10.0} step={0.1} value={r.scale} updateValue={updateScale} />
      </div>
      <div className={styles.images}>
        {r.images.map((im, i) => (
          <img src={im} key={im} alt="recipe" />
        ))}
      </div>
      <div className={styles.recipeMain}>
        <section id={styles.ingredients} className={styles.ingredientsDiv}>
          <h3>Ingredients</h3>
          {toRender.ingredients}
        </section>
        <section id={styles.steps} className={styles.stepsDiv}>
          <h3>Steps</h3>
          {toRender.steps}
        </section>
      </div>
    </div>
    <h3>Overall recipe notes</h3>
    <img src="/icons/voice-note.png" style={{height: 20, marginLeft:10, position: 'relative', top: 3}}
         onClick={() => addAnnotation({recipe: r, target: null, sessionId, updateCurrent})} />
    {renderAnnotations({recipe: r, target: null, updateCurrent})}
    </>
  );
};

export const Active = () => {
  const actives = useAtomValue(activesAtom);
  const error = useAtomValue(errorAtom);
  const name = useAtomValue(focusedAtom);
  const r = useAtomValue(currentAtom);
  const sessionId = useAtomValue(sessionIdAtom);
  console.log('in Active', actives, error, name);
  useEffect(() => {
    logState({_name: 'active-active', name, current: actives[name], sessionId});
  }, [actives, name]);
  if (Object.keys(actives).length === 0 || error.length > 0) {
    return (
      <h1>Error: {error}</h1>
    );
  }
  let comments = null;
  const dish = actives[name].dish || null;
  if (dish && dish.comments) {
    comments = (
      <div className={styles.comments}>
        <h3>Comments</h3>
        {dish.comments.map((c, i) => (
          <div key={i} className={styles.commentDiv}>
            <span className={styles.ts}>{c.timestamp}</span>
            <pre className={styles.note}>{c.notes}</pre>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className={styles.active}>
      <Recipe r={actives[name]} />
      {comments}
      <JsonView data={r} style={defaultStyles} shouldExpandNode={()=>false} clickToExpandNode={true} />
    </div>
  );
};
